import React, { useState, useEffect } from 'react';
import {
    Layout,
    Select,
    Input,
    Button,
    Table,
    Modal,
    message,
    Form,
    Row,
    Col,
    InputNumber, DatePicker, AutoComplete,
} from 'antd';
import axios from 'axios';
import {copyToClipboard, fetchTokenOptions, formattedAddress} from "../../util";

const { Content } = Layout;
const { Option } = Select;

const { RangePicker } = DatePicker;
const ProjectGroupManagement = () => {
    const [walletGroups, setWalletGroups] = useState([]);
    const [projectData, setProjectData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [projectList, setProjectList] = useState([]);  // 用于存储项目列表
    const [selectedAccountProject, setSelectedAccountProject] = useState(null);
    const [selectedCreateTradeProject, setSelectedCreateTradeProject] = useState(null);
    const [selectedTradeInfoProject, setSelectedTradeInfoProject] = useState(null);
    const [chains, setChains] = useState([]);  // 新增：存储链的列表
    const [selectedChain, setSelectedChain] = useState(null);  // 新增：选中的链
    const [addWalletModalVisible, setAddWalletModalVisible] = useState(false);
    const [selectedWalletGroup, setSelectedWalletGroup] = useState(null);
    const [form] = Form.useForm();
    const [selectedProjectDetails, setSelectedProjectDetails] = useState(null);
    const [selectedGroup, setSelectedGroup] = useState(null); // selected wallet group
    const [tradingGroups, setTradingGroups] = useState([]); // data for trading groups
    const [depuedTradingGroups, setDepuedTradingGroups] = useState([]);
    const [totalItems, setTotalItems] = useState(0); // total items for pagination
    const [searchParams, setSearchParams] = useState({}); // search params for API
    const [transactionModalVisible, setTransactionModalVisible] = useState(false);
    const [transactionDetails, setTransactionDetails] = useState([]);
    const [tokenOptions, setTokenOptions] = useState({});
    const [deleteModalVisible, setDeleteModalVisible] = useState(false);
    const [selectedStopGroupId, setSelectedStopGroupId] = useState(null);

    const [pairTokenOptions, setPairTokenOptions] = useState([]);

    useEffect(() => {
        if (selectedCreateTradeProject) {
            const selectedProject = projectList.find(p => p.project_name === selectedCreateTradeProject);
            if (selectedProject) {

                const chain = chains.find(c => c.chain_id === selectedProject.chain_id);
                const tokens = tokenOptions[chain?.chain_name] || [];
                const uniqueOptions = Array.from(new Map(
                    tokens.map(token => [token.address, {
                        value: token.address,
                        label: `${token.name} - ${token.address}`,
                    }])
                ).values());
                setPairTokenOptions(uniqueOptions);
            } else {
                setPairTokenOptions([]);
            }
        } else {
            setPairTokenOptions([]);
        }
    }, [selectedCreateTradeProject, projectList, tokenOptions]);

    useEffect(() => {
        const loadTokenOptions = async () => {
            const data = await fetchTokenOptions();
            setTokenOptions(data);
        };

        loadTokenOptions();
    }, []);

    useEffect(() => {
        fetchWalletGroups();
        fetchChains(); // 获取链的列表
        fetchProjects();
        fetchTradingGroups();
    }, []);

    useEffect(() => {
        fetchProjectAccounts();
    }, [selectedAccountProject])

    // useEffect(() => {
    //     fetchTradingGroups();
    // }, [selectedTradeInfoProject, ])

    const fetchChains = async () => {
        try {
            const response = await axios.get('/api/v1/chain/list');
            if (response.data.code === 0) {
                setChains(Object.values(response.data.data));  // 提取链的列表
            } else {
                message.error(response.data.data);
            }
        } catch(error) {
            message.error(error);
        }
    };

    const handleStopTradingGroup = async () => {
        if (!selectedStopGroupId) {
            message.warning('请选择交易组 ID');
            return;
        }

        try {
            const token = localStorage.getItem('token');
            const response = await axios.post(
                '/api/v1/trading/group/stop',
                { task_id: parseInt(selectedStopGroupId) },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data.code === 0) {
                message.success('交易组已停止');
                fetchTradingGroups(); // 刷新交易组列表
                setSelectedStopGroupId(null);
            } else {
                message.error(response.data.msg || '停止失败');
            }
        } catch (error) {
            console.error('停止交易组失败:', error);
            message.error('网络错误，无法停止交易组');
        }
    };


    // 获取钱包组列表
    const fetchWalletGroups = async (name = '') => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get('/api/v1/wallet/list', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: { name, page: 1, size: 999 },
            });
            if (response.data.code === 0) {
                setWalletGroups(response.data.data.items);
            } else {
                message.error(response.data.data);
            }
        } catch(error) {
            message.error(error);
        }
    };

    // 查询项目组账户信息
    const fetchProjects = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/api/v1/projects/list`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            if (response.data.code === 0) {
                setProjectList(response.data.data.item);
            } else {
                message.error(response.data.data);
            }
        } catch(error) {
            message.error(error);
        } finally {
            setLoading(false);
        }
    };

    const fetchProjectAccounts = async () => {
        if (!selectedAccountProject) {
            message.warning('请选择项目');
            return;
        }
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get('/api/v1/projects/accounts', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: { project_name: selectedAccountProject },
            });

            if (response.data.code === 0) {
                setProjectData(response.data.data.items);
            } else {
                message.error(response.data.data);
            }
        } catch (error) {
            message.error(error);
        } finally {
            setLoading(false);
        }
    };


    // 添加钱包组到项目组
    const handleAddWalletToProject = async () => {
        if (!selectedWalletGroup || !selectedAccountProject) {
            message.warning('请选择钱包组和项目');
            return;
        }

        try {
            const token = localStorage.getItem('token');
            const response = await axios.post('/api/v1/projects/wallet/add', {
                group_id: selectedWalletGroup,
                project_name: selectedAccountProject,
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.data.code === 0) {
                message.success('钱包组添加成功');
                setAddWalletModalVisible(false);
                fetchProjectAccounts();
            } else {
                message.error(response.data.data);
            }
        } catch(error) {
            message.error(error);
        }
    };

    // 打开删除钱包组弹窗
    const openDeleteModal = () => {
        if (!selectedAccountProject) {
            return message.warning('请先选择一个项目');
        }
        setDeleteModalVisible(true);
    };

    // 确认删除
    const handleDeleteWalletGroup = async () => {
        if (!selectedGroup) {
            return message.warning('请选择要删除的钱包组');
        }
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            await axios.post('/api/v1/projects/wallet/remove', {
                group_id: selectedGroup,
                project_name: selectedAccountProject,
            },
                {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            message.success('删除成功');
            setDeleteModalVisible(false);
            fetchProjectAccounts(); // 刷新数据
        } catch (error) {
            console.error(error);
            message.error('删除失败');
        } finally {
            setLoading(false);
        }
    };


    // 更新项目组内钱包余额
    const handleUpdateBalances = async () => {
        const groupId = 1; // Replace with actual selected wallet group id
        const projectName = selectedAccountProject;

        try {
            const response = await axios.post('/api/v1/projects/wallet/refresh', {
                group_id: groupId,
                project_name: projectName,
            });

            if (response.data.code === 0) {
                const { estimate_finish_second } = response.data.data;
                if (estimate_finish_second === 0) {
                    message.success('项目组余额已成功刷新');
                } else {
                    message.success(`余额刷新中，预计完成时间：${estimate_finish_second}秒`);
                }
            } else {
                message.error('更新钱包余额失败');
            }
        } catch {
            message.error('网络错误，无法更新钱包余额');
        }
    };

    // 创建交易组
    const createTradingGroup = async (values) => {
        setLoading(true);
        const token = localStorage.getItem('token');

        const payload = {
            project_name: values.project_name,  // 使用项目名称
            group_id: values.group_id,
            total_amount: parseFloat(values.total_amount),  // 代币总数量
            price_limit: values.price_limit.toString(),
            duration_minutes: values.duration_minutes,
            pair_token_address: values.pair_token_address,
            direction: values.direction,
            transaction_count: values.transaction_count, // 总交易次数
        };

        try {
            const response = await axios.post('/api/v1/trading/group/create', payload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.data.code === 0) {
                message.success('交易组创建成功');
                fetchTradingGroups();
            } else {
                handleTradingGroupError(response.data.code, response.data.data);
            }
        } catch(error) {
            message.error(error);
        } finally {
            setLoading(false);
        }
    };

    // 处理创建交易组错误码
    const handleTradingGroupError = (code, msg) => {
        switch (code) {
            case 4005:
                message.error('无效的交易对');
                break;
            case 4006:
                message.error('价格限制无效');
                break;
            default:
                message.error(msg);
                break;
        }
    };

    // 查询交易组列表
    const fetchTradingGroups = async (values = {}) => {
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                throw new Error('Token is missing');
            }

            const { time_range, page = 1, size = 20, project_name, trading_group_id, group_id } = values;

            let start_time_epoch = null;
            let end_time_epoch = null;

            // 获取时间范围并转换为时间戳
            if (time_range && time_range.length === 2) {
                start_time_epoch = new Date(time_range[0]).setHours(0, 0, 0, 0) / 1000;
                end_time_epoch = new Date(time_range[1]).setHours(23, 59, 59, 0) / 1000;
            }

            const response = await axios.get('/api/v1/trading/group/list', {
                params: {
                    project_name,
                    trading_group_id,
                    group_id,
                    start_time: start_time_epoch,
                    end_time: end_time_epoch,
                    page,
                    size,
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.data.code === 0) {
                setTradingGroups(response.data.data.items); // 设置数据
                setTotalItems(response.data.data.total); // 设置总记录数
            } else {
                message.error(response.data.msg);
            }
        } catch (error) {
            console.error('Error fetching trading groups:', error);
            message.error('网络错误，无法加载交易组列表');
        } finally {
            setLoading(false);
        }
    };


    // 查询交易详情
    // Function to fetch transaction details
    const fetchTransactionDetails = async (tradingGroupId) => {
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/api/v1/trading/group/info`, {
                params: { task_id: tradingGroupId },
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.data.code === 0) {
                const transactionDetails = response.data.data.items.map(item => ({
                    ...item,
                    direction: response.data.data.direction, // 将 direction 添加到每个交易项中
                }));
                console.log(transactionDetails); // For debugging: log the transaction details

                // Set state to store the transaction details and show the modal
                setTransactionDetails(transactionDetails);
                setTransactionModalVisible(true);
            } else {
                message.error(response.data.data);
            }
        } catch (error) {
            message.error(error);
        } finally {
            setLoading(false);
        }
    };

    // 去重函数，根据 group_id 去重
    const uniqueProjectData = (projectData) => {
        return projectData.reduce((acc, current) => {
            const exists = acc.find(item => item.group_id === current.group_id);
            if (!exists) {
                acc.push(current);
            }
            return acc;
        }, []);
    }

    // 表格列定义
    const projectColumns = [
        { title: '序号', render: (_, __, index) => index + 1 },
        { title: '钱包组名', dataIndex: 'group_name',
            sorter: (a, b) => a.group_name.localeCompare(b.group_name), // 字符串排序
        },
        {
            title: '地址',
            dataIndex: 'address',
            render: (text, record) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {/* 地址链接 */}
                    <a href={record.scan_url || `https://basescan.org/address/${text}`}
                       target="_blank"
                       rel="noopener noreferrer">
                        {formattedAddress(text)}
                    </a>

                    {/* 复制按钮 */}
                    <Button
                        size="small"
                        onClick={() => copyToClipboard(text)}>
                        复制
                    </Button>
                </div>
            ),
        },
        { title: '链类型', dataIndex: 'chain_type' },
        {
            title: '代币余额',
            dataIndex: 'token_balance',
            sorter: (a, b) => Number(a.token_balance) - Number(b.token_balance), // 数字排序
        },
        {
            title: 'Gas 币余额',
            dataIndex: 'gas_balance',
            sorter: (a, b) => Number(a.gas_balance) - Number(b.gas_balance),
        },
        {
            title: 'USDC 余额',
            dataIndex: 'usdc_balance',
            sorter: (a, b) => Number(a.usdc_balance) - Number(b.usdc_balance),
        },
        {
            title: 'USDT 余额',
            dataIndex: 'usdt_balance',
            sorter: (a, b) => Number(a.usdt_balance) - Number(b.usdt_balance),
        },
    ];

    const tradingGroupColumns = [
        {
            title: '序号',
            dataIndex: 'index',
            render: (_, __, index) => index + 1,
            width: 60,  // 设置宽度
        },
        {
            title: '任务ID',
            dataIndex: 'task_id',  // "task_id" corresponds to the trading group ID
            width: 100,  // 设置宽度
        },
        {
            title: '项目名',
            dataIndex: 'project_name',  // "project_name" from the response
            width: 150,  // 设置宽度
        },
        {
            title: '开始时间',
            dataIndex: 'start_time',
            render: (timestamp) => new Date(timestamp * 1000).toLocaleString(),  // Convert UNIX timestamp to human-readable date
            width: 120,  // 设置宽度
        },
        {
            title: '预计结束时间',
            dataIndex: 'estimated_end_time',
            render: (timestamp) => new Date(timestamp * 1000).toLocaleString(),  // Convert UNIX timestamp to human-readable date
            width: 120,  // 设置宽度
        },
        {
            title: '操作标的 Trading Pair',
            // render: (text, record) => `${formattedAddress(record.pair_token_address)}`,  // Display project token and pair token addresses
            render: (text, record) => (

                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {formattedAddress(record.pair_token_address)}
                    <Button
                        size="small"
                        onClick={() => copyToClipboard(record.pair_token_address)}>
                        复制
                    </Button>
                </div>
            ),
            width: 60,  // 设置宽度
        },
        {
            title: '总金额',
            dataIndex: 'total_amount',  // "total_amount" from the response
            width: 120,  // 设置宽度
            render: (text) => {
                // 使用Number来处理大数字，并保留四位有效数字
                const formattedAmount = Number(text).toExponential(2);
                return `${formattedAmount}`;
            },
        },
        {
            title: '完成钱包数',
            render: (text, record) => `${record.completed_account_count}/${record.total_account_count}`,  // Display the completed account count and total account count
            width: 160,  // 设置宽度
        },
        {
            title: '操作',
            render: (_, record) => <Button onClick={() => fetchTransactionDetails(record.task_id)}>查看详情</Button>,  // Clicking will show details based on task_id
            width: 120,  // 设置宽度
        },
    ];

    // Table columns to display the transaction details
    const transactionColumns = [
        { title: '序号', render: (_, __, index) => index + 1 }, // 行号
        { title: '交易组ID', render: (_, record) => record.id }, // 交易组ID 使用items里的id
        { title: '买入 / 卖出', render: (_, record) => record.direction === 'BUY' ? '买入' : '卖出' }, // 买入/卖出，基于direction字段
        { title: '成交价格', dataIndex: 'executed_price' }, // 成交价格
        { title: '计划时间', dataIndex: 'expire_time', render: (text) => new Date(text * 1000).toLocaleString() }, // 转为时间戳展示
        { title: '交易者地址', dataIndex: 'trader_address',
            // render: (address) => formattedAddress(address)
            render: (text, record) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <a href={record.trader_scan_url}>{formattedAddress(text)}</a>
                    <Button
                        size="small"
                        onClick={() => copyToClipboard(text)}>
                        复制
                    </Button>
                </div>
            )
        },
        {title: '最低接收数量', dataIndex: 'amount_out_min'},
        {title: '数量', dataIndex: 'amount'},
        { title: '状态', dataIndex: 'status' },
        { title: '交易哈希', dataIndex: 'tx_hash', render: (text, record) => {
                // 如果 scan_url 为空
                if (!record.scan_url) {
                    return <a href={`https://basescan.org/address/${text}`} target="_blank" rel="noopener noreferrer">
                        {formattedAddress(text)}
                    </a>;
                }

                // 如果 scan_url 存在，则显示超链接
                return (
                    <a href={record.scan_url} target="_blank" rel="noopener noreferrer">
                        {formattedAddress(text)}
                    </a>
                );
            },
        },
        // { title: '操作', dataIndex: 'scan_url', render: (url) => <a href={url} target="_blank" rel="noopener noreferrer">scanurl</a> }
    ];

    const handleProjectChange = (value) => {
        setSelectedAccountProject(value);
        console.log('selected pro', value);
        const selectedProject = projectList.find(p => p.project_name === value);
        setSelectedProjectDetails(selectedProject || null);
    };

    return (
        <Content style={{padding: '20px'}}>
            {/* 查询项目组账户信息 */}
            <Row gutter={16} align="middle" style={{ display: 'flex', flexWrap: 'nowrap' }}>
                {/* 项目选择 */}
                <Col span={6}>
                    <Form.Item
                        label="项目名"
                        name="project_name"
                        rules={[{ required: true, message: '请选择项目名' }]}
                        style={{ marginBottom: 0 }}
                    >
                        <Select
                            allowClear
                            placeholder="请选择项目"
                            value={selectedAccountProject}
                            onChange={handleProjectChange}
                            loading={loading}
                            style={{ width: '100%' }}
                        >
                            {projectList.map(project => (
                                <Option key={project.id} value={project.project_name}>
                                    {project.project_name}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>

                {/* 按钮 */}
                <Col span={7} style={{ display: 'flex', gap: '8px' }}>
                    <Button type="primary" onClick={fetchProjectAccounts} loading={loading}>
                        更新余额
                    </Button>
                    <Button type="primary" onClick={() => setAddWalletModalVisible(true)}>
                        添加钱包组
                    </Button>
                    <Button danger onClick={openDeleteModal}>
                        删除钱包组
                    </Button>
                </Col>

                {/* Token 地址 + 复制 */}
                {selectedProjectDetails && selectedProjectDetails.token_address && (
                    <>
                        <Col span={6} style={{ display: 'flex', alignItems: 'right', gap: '2px' }}>
                            <span>项目Token地址:</span>
                            {formattedAddress(selectedProjectDetails.token_address)}
                            <Button size="small" onClick={() => copyToClipboard(selectedProjectDetails.token_address)}>
                                复制
                            </Button>
                        </Col>

                        {/* 相关链接 */}
                        {selectedProjectDetails.scan_url && (
                            <Col>
                                <a href={selectedProjectDetails.scan_url} target="_blank" rel="noopener noreferrer">
                                    Scan URL
                                </a>
                            </Col>
                        )}
                        {selectedProjectDetails.dextool_url && (
                            <Col>
                                <a href={selectedProjectDetails.dextool_url} target="_blank" rel="noopener noreferrer">
                                    Dextool URL
                                </a>
                            </Col>
                        )}
                        {selectedProjectDetails.dexscreener_url && (
                            <Col>
                                <a href={selectedProjectDetails.dexscreener_url} target="_blank" rel="noopener noreferrer">
                                    Dexscreener URL
                                </a>
                            </Col>
                        )}
                        {selectedProjectDetails.gmgn_url && (
                            <Col>
                                <a href={selectedProjectDetails.gmgn_url} target="_blank" rel="noopener noreferrer">
                                    GMGN URL
                                </a>
                            </Col>
                        )}
                    </>
                )}
            </Row>


            {/* Add Wallet Modal */}
            <Modal
                title="选择钱包组"
                visible={addWalletModalVisible}
                onCancel={() => setAddWalletModalVisible(false)}
                footer={null}
                width={600}
            >
                <Form>
                    <Form.Item label="选择钱包组" name="wallet_group">
                        <Select
                                        allowClear
                            placeholder="选择钱包组"
                            value={selectedWalletGroup}
                            onChange={setSelectedWalletGroup}
                            style={{width: '100%'}}
                        >
                            {walletGroups
                                .filter(group => !projectData.some(project => project.group_name === group.name)) // 排除项目中已存在的钱包组
                                .map(group => (
                                    <Option key={group.group_id} value={group.group_id}>
                                        {group.name}
                                    </Option>
                                ))}
                        </Select>
                    </Form.Item>
                    <Form.Item>
                        <Button
                            type="primary"
                            onClick={handleAddWalletToProject}
                            block
                        >
                            确定添加
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>

            {/* 删除钱包组弹窗 */}
            <Modal
                title="删除钱包组"
                visible={deleteModalVisible}
                onCancel={() => setDeleteModalVisible(false)}
                onOk={handleDeleteWalletGroup}
                okText="确定删除"
                confirmLoading={loading}
                destroyOnClose
            >
                <Row gutter={16} align="middle" style={{ marginBottom: 16 }}>
                    <Col span={8}>选择钱包组：</Col>
                    <Col span={16}>
                        <Select
                            style={{ width: '100%' }}
                            placeholder="请选择钱包组"
                            onChange={(value) => setSelectedGroup(value)}
                            allowClear
                        >
                            {/*{projectData.map((item) => (*/}
                            {/*    <Option key={item.group_id} value={item.group_id}>*/}
                            {/*        {item.group_name}*/}
                            {/*    </Option>*/}
                            {/*))}*/}

                            {uniqueProjectData(projectData).map((item) => (
                                <Option key={item.group_id} value={item.group_id}>
                                    {item.group_name}
                                </Option>
                            ))}
                        </Select>
                    </Col>
                </Row>
            </Modal>

            {/* 项目组账户列表 */}
            <Table
                rowKey="address"
                columns={projectColumns}
                dataSource={projectData}
                loading={loading}
                pagination={{pageSize: 10,
                    showSizeChanger: false
            }}
            />

            {/* 创建交易组 和 查询交易组列表 */}
            <Row gutter={16}>
                {/* 创建交易组 */}
                <Col span={10}>
                    <Form form={form} onFinish={createTradingGroup} layout="vertical">
                        <h2>交易组发出</h2>

                        {/* 第一行：钱包组、账户数量、总价值、价格限制 */}
                        <Row gutter={16}>
                            <Col span={6}>
                                <Form.Item
                                    label="买入 / 卖出"
                                    name="direction"
                                    rules={[{required: true, message: '请选择买入或卖出'}]}
                                >
                                    <Select
                                        allowClear>
                                        <Option value="BUY">买入</Option>
                                        <Option value="SELL">卖出</Option>
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={6}>
                                <Form.Item
                                    label="钱包组"
                                    name="group_id"
                                    rules={[{required: true, message: '请选择钱包组'}]}
                                >
                                    <Select
                                        allowClear
                                        showSearch
                                        placeholder="选择钱包组"
                                        onSearch={fetchWalletGroups}
                                        style={{width: '100%'}}
                                    >
                                        {walletGroups.map((group) => (
                                            <Option key={group.group_id} value={group.group_id}>
                                                {group.name}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={6}>
                                <Form.Item
                                    label="项目名"
                                    name="project_name"
                                    rules={[{required: true, message: '请选择项目名'}]}
                                >
                                    <Select
                                        allowClear
                                        showSearch
                                        placeholder="选择项目"
                                        value={selectedCreateTradeProject}
                                        onChange={setSelectedCreateTradeProject}
                                        loading={loading}
                                        style={{width: '100%'}}
                                    >
                                        {projectList.map(project => (
                                            <Option key={project.id} value={project.project_name}>
                                                {project.project_name}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>

                            {/* 项目Token总数量 */}
                            <Col span={6}>
                                <Form.Item
                                    label="Token总数"
                                    name="total_amount"
                                    rules={[{required: true, message: '请输入项目Token总数量'},
                                        {type: 'number', min: 0, message: '必须大于0'},
                                    ]}
                                >
                                    <InputNumber
                                        style={{width: '100%'}}
                                        min={0}
                                        step={1}
                                        placeholder="项目Token总数量"
                                    />
                                </Form.Item>
                            </Col>

                        </Row>

                        {/* 第二行：执行时间、交易对、买入/卖出、总交易次数 */}
                        <Row gutter={16}>
                            <Col span={6}>
                                <Form.Item
                                    label="价格限制($)"
                                    name="price_limit"
                                    rules={[
                                        {required: true, message: '请输入价格限制'},
                                        {type: 'number', min: 0, message: '必须大于0'},
                                    ]}
                                >
                                    <InputNumber style={{width: '100%'}} min={0}/>
                                </Form.Item>
                            </Col>

                            <Col span={6}>
                                <Form.Item
                                    label="执行时间(分)"
                                    name="duration_minutes"
                                    rules={[
                                        {required: true, message: '请输入执行总时间'},
                                        {type: 'number', min: 1, message: '必须大于0'},
                                        {
                                            validator: (_, value) =>
                                                Number.isInteger(+value) && +value > 0
                                                    ? Promise.resolve()
                                                    : Promise.reject(new Error('执行时间必须为正整数')),
                                        },
                                    ]}
                                >
                                    <InputNumber style={{width: '100%'}} min={1}/>
                                </Form.Item>
                            </Col>

                            <Col span={12}>
                                <Form.Item
                                    label="对手方地址"
                                    name="pair_token_address"
                                    rules={[{required: true, message: '请输入交易对手方地址'}]}
                                >

                                    <AutoComplete
                                        placeholder="对手方地址"
                                        onChange={(value) => form.setFieldsValue({ pair_token_address: value })}
                                        style={{ width: '100%' }}
                                        options={pairTokenOptions}
                                        filterOption={(inputValue, option) =>
                                            option.label.toLowerCase().includes(inputValue.toLowerCase())
                                        }
                                    />

                                </Form.Item>
                            </Col>

                        </Row>

                        {/* 第三行：确认按钮 */}
                        <Form.Item>
                            <Button type="primary" htmlType="submit" loading={loading} block>
                                确认
                            </Button>
                        </Form.Item>
                    </Form>

                    <Col span={24}> {/* 改为 span=24，占满整行避免被挤 */}
                        <h2>停止交易</h2>
                        <Row gutter={16} align="middle">
                            <Col span={18}>
                                <Input
                                    placeholder="请输入交易组ID"
                                    style={{ width: '100%' }}
                                    value={selectedStopGroupId}
                                    onChange={(e) => setSelectedStopGroupId(e.target.value)}
                                    allowClear
                                />
                            </Col>
                            <Col span={6}>
                                <Button
                                    danger
                                    onClick={handleStopTradingGroup}
                                    block
                                    style={{
                                        height: '30px', // 设置按钮高度
                                        lineHeight: '40px', // 文本居中
                                        fontSize: '16px' // 可选：字体更大一点
                                    }}
                                >
                                    停止
                                </Button>
                            </Col>
                        </Row>
                    </Col>


                </Col>

                {/* 查询交易组列表 */}
                <Col span={14}>
                    <h2>交易组记录</h2>
                    <Form
                        layout="vertical"
                        onFinish={fetchTradingGroups} // 只在点击查询按钮时请求数据
                        style={{ width: '100%' }}
                    >
                        {/* 第一行：项目选择、交易组ID、钱包组ID */}
                        <Row gutter={16}>
                            <Col span={8}>
                                <Form.Item
                                    label="项目名"
                                    name="project_name"
                                    rules={[{ required: false, message: '请选择项目名' }]}
                                >
                                    <Select
                                        allowClear
                                        showSearch
                                        placeholder="选择项目"
                                        value={selectedTradeInfoProject}
                                        onChange={setSelectedTradeInfoProject}
                                        loading={loading}
                                        style={{ width: '100%' }}
                                    >
                                        {projectList.map((project) => (
                                            <Option key={project.id} value={project.project_name}>
                                                {project.project_name}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="交易组ID"
                                    name="trading_group_id"
                                    style={{ width: '100%' }}
                                >
                                    <Input placeholder="请输入交易组ID" style={{ width: '100%' }} />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="钱包组ID"
                                    name="group_id"
                                    rules={[{ required: false, message: '请选择钱包组ID' }]}
                                >
                                    <Select
                                        allowClear
                                        showSearch
                                        placeholder="选择钱包组"
                                        value={selectedGroup}
                                        onChange={setSelectedGroup}
                                        style={{ width: '100%' }}
                                    >
                                        {walletGroups.map((group) => (
                                            <Option key={group.group_id} value={group.group_id}>
                                                {group.name}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>

                        {/* 第二行：时间范围和查询按钮 */}
                        <Row gutter={16} align="bottom">
                            <Col span={12}>
                                <Form.Item
                                    label="时间范围"
                                    name="time_range"
                                    style={{ width: '100%' }}
                                    rules={[
                                        { required: false, message: '请选择时间范围' },
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                if (!value || value[0] <= value[1]) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject(new Error('结束时间必须晚于开始时间'));
                                            },
                                        }),
                                    ]}
                                >
                                    <RangePicker
                                        style={{ width: '100%' }}
                                        format="YYYY-MM-DD"
                                        placeholder={['起始时间', '终止时间']}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item>
                                    <Button type="primary" htmlType="submit" block>
                                        查询
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>


                    {/* 表格展示 */}
                    <Table
                        rowKey="task_id"
                        columns={tradingGroupColumns}
                        dataSource={tradingGroups} // 需要在state中存储获取的数据
                        loading={loading}
                        pagination={{
                            pageSize: 10,
                            showSizeChanger: false,
                            total: totalItems, // 总记录数
                            onChange: (page, pageSize) => {
                                // 这里可以传递分页信息
                                fetchTradingGroups({...searchParams, page, size: pageSize});
                            },
                        }}
                    />
                </Col>
            </Row>

            <Modal
                title="交易组详情"
                visible={transactionModalVisible}
                onCancel={() => setTransactionModalVisible(false)}
                footer={null}
                width={1600} // Optional: adjust modal width
            >
                <Table
                    rowKey="id"
                    columns={transactionColumns}
                    dataSource={transactionDetails}
                    pagination={{ pageSize: 10 }} // Adjust pagination as necessary
                    loading={loading}
                />
            </Modal>

        </Content>
    );
};

export default ProjectGroupManagement;
